import { Component } from 'preact'

export default class NewPaybarNotificationExternalFormValidationMessage extends Component {
  get content() {
    return window.application.newPaybar?.externalForm?.validationMessage
  }

  render() {
    return (
      <div className="newPaybarNotificationExternalFormValidationMessage">
        <span
          className="newPaybarNotice-message"
          dangerouslySetInnerHTML={{ __html: this.content }} />
      </div>
    )
  }
}

